/**
 * API响应的通用类型定义
 */
export interface ApiResponse<T = any> {
  code: number
  message: string
  data: T
}

/**
 * 业务错误类型
 */
export class BusinessError extends Error {
  code: number
  data: any

  constructor(message: string, code: number, data?: any) {
    super(message)
    this.name = 'BusinessError'
    this.code = code
    this.data = data
  }
}

/**
 * 检查是否为成功的API响应
 */
export function isSuccessResponse(response: ApiResponse): boolean {
  return response.code >= 0
}

/**
 * 检查是否为业务错误
 */
export function isBusinessError(error: any): error is BusinessError {
  return error && error.name === 'BusinessError'
}
